import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

export default function AddVideoDialog({ open, onOpenChange }) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: (url) => api.post("/videos", { url }),
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({ queryKey: ["videos"] });
      setUrl("");
      onOpenChange(false);
      navigate(`/player/${data.id}`);
    },
    onError: (e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    mutation.mutate(url);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="add-video-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Добавить видео</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-md px-3 py-2" data-testid="add-video-error">
              {error}
            </div>
          )}
          <Input
            autoFocus
            placeholder="https://www.youtube.com/watch?v=..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            data-testid="add-video-url-input"
          />
          <Button type="submit" className="w-full" disabled={mutation.isPending || !url} data-testid="add-video-submit-button">
            {mutation.isPending ? <Loader2 className="w-4 h-4 animate-spin" /> : "Добавить"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
